import { useParams } from 'react-router-dom';

import DynamicZones from '../components/DynamicZones';

export const CollectionComponentContentPage = () => {
  const { pageId: id } = useParams<{ pageId: string }>();

  return (
    <div className="w-full">
      {id && <DynamicZones collectionComponentId={id} />}
    </div>
  );
};
